import React, { useContext, useEffect, useState } from "react";
import Row from "@amzn/meridian/row";
import ControlGroup from "@amzn/meridian/control-group";
import Checkbox from "@amzn/meridian/checkbox";
import RadioButton from "@amzn/meridian/radio-button";
import Column from "@amzn/meridian/column";
import PVAChart from "./PVAChartv2";
import { PVAOverviewContext } from "../overview/context/PVAOverviewContext";
import { FormattedMessage } from "react-intl";
import Heading from "@amzn/meridian/heading";
import { MobileDisplay } from "../common/MobileDisplay";
import { useDeviceLayout } from "../common/context/DeviceLayoutContext";
import Select, { SelectOption } from "@amzn/meridian/select";
import Text from "@amzn/meridian/text";
import { logCustomMetric } from "../overview/utils/utils";

const ChartView = (data) => {
  const { pvaData, dispatch } = useContext(PVAOverviewContext);
  const [checkedIds, setCheckedIds] = useState(
    pvaData.pvaGraphData
      ? new Set(pvaData.pvaGraphData.processName)
      : new Set(["induct"]),
  );
  const { spacingInset_shorthand2, isMobile } = useDeviceLayout();
  const widths = isMobile ? ["100%", "100%"] : ["grid-2", "grid-10"];

  const getOption = (processName) => {
    return processName === "inbound"
      ? [
          { key: "inbound", value: "chart.inbound", defaultMessage: "Arrive" },
          { key: "induct", value: "chart.induct", defaultMessage: "Induct" },
          {
            key: "stowWip",
            value: "chart.stowWip",
            defaultMessage: "Stow WIP",
          },
          { key: "sort", value: "chart.sort", defaultMessage: "Sort" },
        ]
      : [
          { key: "pick", value: "chart.pick", defaultMessage: "Pick" },
          { key: "stage", value: "chart.stage", defaultMessage: "Stage" },
        ];
  };

  const handleMultiSelectChange = (value) => {
    if (
      value !== undefined &&
      value.length > 1 &&
      value[value.length - 1] === "stowWip"
    ) {
      value = value.filter((option) => {
        return option === "stowWip";
      });
    } else if (value.length >= 1 && value[0] === "stowWip") {
      value = value.filter((option) => {
        return option !== "stowWip";
      });
    }

    dispatch({ type: "SET_PVA_GRAPH_PROCESS", data: { processName: value } });
  };

  const handleChange = ({ key, checked }) => {
    if (checked) {
      key === "stowWip" ? checkedIds.clear() : checkedIds.delete("stowWip");
      checkedIds.add(key);
      logCustomMetric("Sortation Flow Change", key);
    } else {
      checkedIds.delete(key);
    }
    setCheckedIds(new Set(checkedIds));
    dispatch({
      type: "SET_PVA_GRAPH_PROCESS",
      data: { processName: [...checkedIds] },
    });
  };

  useEffect(() => {
    if (data.view.processName === "outbound") {
      dispatch({
        type: "SET_PVA_GRAPH_PROCESS",
        data: { processName: ["pick", "stage"] },
      });
    }
  }, []);

  const IntervalFilterGroup = () => (
    <ControlGroup
      name="toppings"
      onChange={(value) =>
        dispatch({
          type: "SET_PVA_GRAPH_GRANULARITY",
          data: { granularity: value },
        })
      }
      value={pvaData.pvaGraphData.granularity}
    >
      <RadioButton value="15">
        <FormattedMessage id="chart.minute_15" defaultMessage="15 Minutes" />
      </RadioButton>
      <RadioButton value="cumulative_15">
        <FormattedMessage id="chart.cumulative" defaultMessage="Cumulative" />
      </RadioButton>
    </ControlGroup>
  );

  const MultiSelectFlow = () => (
    <React.Fragment>
      <Select
        size="small"
        value={pvaData.pvaGraphData.processName}
        onChange={(value) => handleMultiSelectChange(value)}
        placeholder="Select value..."
        width={200}
      >
        {getOption(data.view.processName).map((option) => (
          <SelectOption
            key={option.key}
            value={option.key}
            label={option.defaultMessage}
          />
        ))}
      </Select>
    </React.Fragment>
  );
  return (
    <div>
      <Row widths={widths} wrap="down" spacingInset={spacingInset_shorthand2}>
        <MobileDisplay visibility={true}>
          <Row spacingInset="small none none none">
            <Column>
              <Text type="h100" alignment="left">
                <FormattedMessage
                  id="chart.sortationFlow"
                  defaultMessage="Sortation Flow"
                />
              </Text>
              <MultiSelectFlow />
            </Column>
            <Column>
              <IntervalFilterGroup />
            </Column>
          </Row>
        </MobileDisplay>
        <MobileDisplay visibility={false}>
          <div>
            <Column spacingInset="medium small">
              <Heading level={2} type="h300" alignment="left">
                <FormattedMessage
                  id="chart.sortationFlow"
                  defaultMessage="Sortation Flow"
                />
              </Heading>
            </Column>
            <ControlGroup
              name="option"
              onChange={(value) =>
                dispatch({
                  type: "SET_PVA_GRAPH_PROCESS",
                  data: { processName: value },
                })
              }
              value={pvaData.pvaGraphData.processName}
            >
              {getOption(data.view.processName).map((option) => (
                <Checkbox
                  key={option.key}
                  value={option.key}
                  checked={checkedIds.has(option.key)}
                  onChange={(e) =>
                    handleChange({ key: option.key, checked: e })
                  }
                >
                  <FormattedMessage
                    id={option.value}
                    defaultMessage={option.defaultMessage}
                  />
                </Checkbox>
              ))}
            </ControlGroup>
            <Column spacingInset="small none none">
              <IntervalFilterGroup />
            </Column>
          </div>
        </MobileDisplay>
        <div>
          {pvaData.overviewData.flowPVAData ? (
            <PVAChart
              breaksDataSources={data.breaksDataSources}
              processName={data.view.processName}
              pvaData={{ pvaData: pvaData }}
            />
          ) : (
            ""
          )}
        </div>
      </Row>
    </div>
  );
};

export default ChartView;



// WEBPACK FOOTER //
// ./src/components/chart/ChartViewv2.js